"use client"
import {
  Sidebar as DSSidebar,
  SidebarAvatar as DSSidebarAvatar,
  SidebarItem as DSSidebarItem,
  SidebarItemTitle as DSSidebarItemTitle,
  type ItemRenderLinkComponent,
} from "@opensea/ui-kit"
import type React from "react"
import type { ItemProps } from "../Item"
import { Link } from "../Link"

export type SidebarItemProps = {
  active?: boolean
  renderItem?: React.ComponentType<ItemProps>
  size?: "sm" | "md"
} & ItemProps

export const Sidebar = DSSidebar

export function SidebarItem(props: SidebarItemProps) {
  return (
    <DSSidebarItem renderLink={Link as ItemRenderLinkComponent} {...props} />
  )
}

export const SidebarItemAvatar = DSSidebarAvatar
export const SidebarItemTitle = DSSidebarItemTitle
